export { default as LandingPage } from './LandingPage/LandingPage'
export { default as DefaultPage } from './DefaultPage/DefaultPage'
export { default as BuildPage } from './BuildPage/BuildPage'
export { default as SearchPage } from './SearchPage/SearchPage'
export { default as CommunityPage } from './CommunityPage/CommunityPage'



// WEBPACK FOOTER //
// ./component/page/index.js